import { DecimalPipe, UpperCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { filter } from 'rxjs';
import { BezugsrechtBackLinkComponent } from '../back-link/bezugsrecht-back-link.component';
import { BezugsrechtBase } from '../bezugsrecht.base';

@Component({
  imports: [TranslocoPipe, RouterLink, BezugsrechtBackLinkComponent, DecimalPipe, ButtonComponent, UpperCasePipe],
  templateUrl: './bezugsrecht-buy.component.html',
})
export class BezugsrechtBuyComponent extends BezugsrechtBase implements OnInit {
  public override ngOnInit(): void {
    super.ngOnInit();

    this.handleRedirects();
  }

  private handleRedirects(): void {
    this.service.bezugsrechtData$
      .pipe(
        filter((data) => !!data),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((data) => {
        if (data.buyableAmount <= 0) {
          this.router.navigateByUrl(`${this.rootUrl}/${this.BEZUGSRECHT_ROUTES.BUY_CUSTOM}`);
        } else if (data.directivePreview) {
          this.router.navigateByUrl(`${this.rootUrl}/${this.BEZUGSRECHT_ROUTES.SUMMARY}`);
        }
      });
  }
}
